/**
 * Phone number row for the Edit Profile form.
 *
 * Mirrors the Email field's pattern (a field whose mutation routes through a different path than the
 * form's bulk Save). Here the number is verified via Firebase Phone Auth (`PhoneLinkState`) rather than
 * saved as free text — the verified phone lands on the Firebase Auth user, which is what the
 * inspiration capture webhook resolves against. The row only shows the current number; adding,
 * changing, and removing it all happen in the app-wide `PhoneVerificationDialog` (ELARA-1169).
 */

import { usePhoneLinkState } from '#states/hooks.js';
import { Badge, Button } from '#ui/index.js';

export function PhoneVerificationField() {
  const phoneLink = usePhoneLinkState();
  const verifiedPhone = phoneLink.verifiedPhone;

  return (
    <div className="space-y-2">
      <p className="block text-sm font-medium mb-2">Phone number</p>

      {verifiedPhone ? (
        <div className="flex flex-wrap items-center gap-3">
          <span className="text-sm">{verifiedPhone}</span>
          <Badge variant="success">Verified</Badge>
          <Button variant="link" size="sm" onClick={() => phoneLink.openSheet()}>
            Manage
          </Button>
        </div>
      ) : (
        <Button onClick={() => phoneLink.openSheet()}>Add phone number</Button>
      )}
    </div>
  );
}
